export default [{
        path: "/member",
        component: (resolve) => require(["../page.vue"], resolve),
        meta: {
            title: "会员管理列表",
            keepAlive: false,
        },
    },
    {
        path: "/member/detail/:id",
        component: (resolve) => require(["../memberDetail.vue"], resolve),
        meta: {
            title: "会员管理详情",
            keepAlive: false,
        },
    },
];